import axios from "axios";

const API_URL = "/api/terms";

export const getTerms = async (sessionId) => {
  const res = await axios.get(API_URL, {
    params: sessionId ? { session_id: sessionId } : {},
  });
  return res.data;
};

export const createTerm = async (payload) => {
  const res = await axios.post(API_URL, payload);
  return res.data;
};

export const updateTerm = async (id, payload) => {
  const res = await axios.put(`${API_URL}/${id}`, payload);
  return res.data;
};

export const deleteTerm = async (id) => {
  const res = await axios.delete(`${API_URL}/${id}`);
  return res.data;
};

export const getTermWeeks = async (termId) => {
  const res = await axios.get(`${API_URL}/${termId}/weeks`);
  return res.data;
};

/** weeks: [{ id, is_available, note? }] */
export const updateTermWeeks = async (termId, weeks) => {
  const res = await axios.put(`${API_URL}/${termId}/weeks`, { weeks });
  return res.data;
};
